import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { StringsWithPrefix } from "@my-dld/utils/Utils";
import Popup from "@my-dld/components/Popup/Popup";

interface Props {

}

interface State {

}

class OwnerCommitteeTermsPopUp extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {} as State;
	}

	componentWillReceiveProps( nextProps: Readonly<Props>, nextContext: any ): void {
		this.setState( { agree: false } );
	}

	render() {
		const formProps = {
			containerClassName: "form-group mb-4 field-style",
			inputClassName: "form-control",
			holder: this,
		};
		let user = TabuProfile.getProfile();
		let disclaimer = Strings.owner_committee_terms;
		let disclaimer_terms = Strings.owner_committee_terms_desc;
		let terms: string[] = [];
		terms = StringsWithPrefix( "owner_committee_terms_val_" );
		return <Popup
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" }
			id={ "ownerCommitteeTermsAndConditions" } title={ Strings.terms_and_conditions }
			showIcon={ false }>
			{ disclaimer }
			{ disclaimer_terms }
			<ol>
				{ terms.map( ( value, index ) => {
					return <li key={ index }>{ value }</li>;
				} ) }
			</ol>
			<div className="modal-footer justify-content-center">
				<button
					type="button" className="btn btn-grey"
					data-bs-dismiss="modal">{ Strings.cancel }</button>
			</div>
		</Popup>;
	}
}

export default OwnerCommitteeTermsPopUp;
